<template>
  <div class="not-found">
    <v-container>
      <div class="display-3 mt-5">
        404 | {{ $t("page-not-found.page-not-found") }}
      </div>
      <div class="mt-10">
        {{ $t("page-not-found.page-not-found-distributed") }}
        <router-link :to="{ name: 'Dashboard' }">
          {{ $t("page-not-found.go-to-dashboard") }}
        </router-link>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style lang="scss" scoped>
.not-found {
  margin: auto;
  margin-top: 10%;
  text-align: center;
}
</style>
